var Common;
(function (Common) {
    var Favourites;
    (function (Favourites) {
        var newFavourites = [];
        var searchCrit = {};
        var FavouritesOwnerType;
        (function (FavouritesOwnerType) {
            FavouritesOwnerType["Profile"] = "Profile";
            FavouritesOwnerType["Outlet"] = "Outlet";
            FavouritesOwnerType["Organisation"] = " Organisation";
        })(FavouritesOwnerType = Favourites.FavouritesOwnerType || (Favourites.FavouritesOwnerType = {}));
        function LoadFavouriteCategories(favouritesModalUrl, favouritesUrl) {
            $("#favourites-processing").show();
            $("#favourites").hide();
            $("#favourites-error").hide();
            $.ajax({
                type: "GET",
                url: window.AppSettings.ApiUrl + "/api/v1/favourites/lists/categories",
                cache: false,
                success: function (result) {
                    var data = result.data;
                    $("#favourites").show();
                    var tmpl = $.templates({ markup: "#favouritesTemplate", allowCode: true });
                    $("#favourites").html(tmpl.render(data));
                    $(".btn-edit").off("click").on("click", function (e) {
                        e.preventDefault();
                        showEditFavourite(e, parseInt($(this).data("favourite")), favouritesModalUrl, favouritesUrl, true);
                    });
                    $(".btn-copy").off("click").on("click", function (e) {
                        e.preventDefault();
                        showEditFavourite(e, parseInt($(this).data("favourite")), favouritesModalUrl, favouritesUrl, false);
                    });
                    var ShareFavoriteModal = Common.SetupShareModal($('#ShareModal-ShareFavorites'));
                    $(".btn-share").off("click").on("click", function (e) {
                        e.preventDefault();
                        ShareFavoriteModal.changeFavoriteShare({ FavoriteID: parseInt($(this).data("favourite-id")), FavoriteName: $(this).data("favourite-name") });
                        $('#ShareModal-ShareFavorites').modal('show');
                    });
                    $(".btn-delete").off("click").on("click", function (e) {
                        e.preventDefault();
                        aria.Utils.AriaAlert("Are you sure you want to remove this favourites list? Showing alert dialog. Enter to accept, escape to cancel.");
                        var favouriteId = $(this).data("favourite");
                        setTimeout(function () {
                            if (confirm("Are you sure you want to remove this favourites list?")) {
                                var reloadAction = function () { LoadFavouriteCategories(favouritesModalUrl, favouritesUrl); };
                                RemoveFavouritesList(favouriteId, favouritesUrl, reloadAction);
                            }
                        }, 500);
                    });
                    Common.SetupTooltipsStyling();
                    $(".btn-remove-favourites-list").on("click", function (e) {
                        e.preventDefault();
                        aria.Utils.AriaAlert("Are you sure you want to remove this favourites list? Showing alert dialog. Enter to accept, escape to cancel.");
                        var favouriteList = $(this).data("favourite-list");
                        setTimeout(function () {
                            if (confirm("Are you sure you want to remove this favourites list?")) {
                                RemoveFavouritesList(favouriteList, favouritesUrl);
                            }
                        }, 500);
                    });
                },
                error: function () {
                    $("#favourites-error").show();
                },
                complete: function () {
                    $("#favourites-processing").hide();
                }
            });
        }
        Favourites.LoadFavouriteCategories = LoadFavouriteCategories;
        function showEditFavourite(evt, favouriteId, favouritesModalUrl, favouritesUrl, edit) {
            // reset form validation
            if ($("#favouritesForm .error").length !== 0) {
                var validator = $("#favouritesForm").validate();
                validator.resetForm();
            }
            $.ajax({
                type: "GET",
                url: favouritesModalUrl.replace("0", favouriteId.toString()).replace("False", edit ? "true" : "false"),
                cache: false,
                success: function (data) {
                    $("#favouritesModal").html($("#favouritesEditModalTemplate").render(data));
                    $("#favouritesModal").modal({ backdrop: "static", show: true });
                    var favouritesModalForm = $("#favouritesForm");
                    favouritesModalForm.validate({
                        ignore: ".ignore",
                        rules: {
                            "FavouriteListName": { required: true },
                            "Category": { required: true }
                        },
                        messages: {
                            "FavouriteListName": { required: "A favourites list name must be provided." },
                            "Category": { required: "A category must be provided." }
                        },
                        highlight: function (element) {
                            $(element).parent().attr("role", "alert");
                        },
                        unhighlight: function (element) {
                            $(element).parent().removeAttr("role");
                        }
                    });
                    var checkboxVisible = !!$("#cbTeamFavourite").length;
                    var scopevisible = !!$("#selectedscope").length;
                    var categoryvisible = !!$("#category").length;
                    var subcategoryvisible = !!$("#subcategory").length;
                    var categoryValue = categoryvisible ? $("#category").val() : undefined;
                    var subCategoryValue = subcategoryvisible ? $("#subcategory").val() : undefined;
                    var $category, $subcategory;
                    if (categoryvisible && subcategoryvisible) {
                        $("#category").addClass("ignore");
                        $subcategory = $("#subcategory").selectize({
                            persist: false,
                            maxItems: 1,
                            valueField: "DataSubCategory",
                            labelField: "SubCategory",
                            searchField: ["SubCategory"],
                            createOnBlur: true,
                            plugins: { "accessibility": { Label: "Optionally, choose a sub-category or enter the name of a new one. Backspace to delete an entry" } },
                            render: {
                                item: function (item, escape) {
                                    return "<div><span>" + escape(item.SubCategory) + "</span></div>";
                                },
                                option: function (item, escape) {
                                    return "<div><span class=\"label\" style=\"color:black;\">" + escape(item.SubCategory) + "</span></div>";
                                }
                            },
                            create: function (input) {
                                return { DataSubCategory: input, SubCategory: input };
                            }
                        });
                        $category = $("#category").selectize({
                            persist: false,
                            maxItems: 1,
                            valueField: "DataCategory",
                            labelField: "Category",
                            searchField: ["Category"],
                            createOnBlur: true,
                            plugins: { "accessibility": { Label: "Choose a category or enter the name of a new one. Backspace to delete an entry" } },
                            render: {
                                item: function (item, escape) {
                                    return "<div><span>" + escape(item.Category) + "</span></div>";
                                },
                                option: function (item, escape) {
                                    var label = item.Category || item.DataCategory;
                                    return "<div><span class=\"label\" style=\"color:black;\">" + escape(label) + "</span></div>";
                                }
                            },
                            create: function (input) {
                                return { DataCategory: input, Category: input };
                            },
                            onChange: function (value) {
                                if (!value.length)
                                    return;
                                setupFavouriteSubCategories(value, true, "");
                            }
                        });
                    }
                    if (scopevisible) {
                        $("#selectedscope").selectize({
                            plugins: {
                                "no-delete": {},
                                "accessibility": { Label: "Would you like to share this favourite with others?" }
                            }
                        });
                        $("#selectedscope").off("change").on("change", function () {
                            doScopeTrigger();
                        });
                        doScopeTrigger();
                    }
                    else if (checkboxVisible) {
                        ($("#cbTeamFavourite")[0]).checked = categoryvisible && categoryValue !== undefined && categoryValue !== "";
                        $("#cbTeamFavourite").off("click touchend").on("click touchend", function () {
                            doCheckBoxTrigger();
                        });
                        doCheckBoxTrigger();
                    }
                    if ($category !== undefined && $subcategory !== undefined) {
                        var categorySelector = $category[0].selectize;
                        var subcategorySelector = $subcategory[0].selectize;
                        categorySelector.setValue(categoryValue);
                        subcategorySelector.setValue(subCategoryValue);
                    }
                    $("#btnUpdateFavourite").data("favourite", favouriteId);
                    $("#btnUpdateFavourite").off("click touchend").on("click touchend", function (e) {
                        e.preventDefault();
                        updateFavourite($(this).data("favourite"), $(this).data("favouritesOwnerType"), favouritesModalUrl, favouritesUrl, edit);
                    });
                },
                error: function () {
                    $.notify({ title: "Error", message: "Something went wrong trying to retrieve favourites.", icon: "glyphicon glyphicon-info-sign" });
                }
            });
        }
        function updateFavourite(favouriteId, favouritesOwnerType, favouritesModalUrl, favouritesUrl, edit) {
            // Ignore validation for IE < 9 as it's broken -- will defer to server-side checks
            if (!(document.all && !document.addEventListener)) {
                var form = $("#favouritesForm");
                if (!form.valid()) {
                    return;
                }
            }
            var listname = $("#favouritename").val();
            var originallistname = $("#originalfavouritename").val();
            var category = $("#category + .selectize-control:visible").length ? $("#category").val() : "";
            var originalcategory = $("#originalcategory").val();
            var subcategory = $("#subcategory + .selectize-control:visible").length ? $("#subcategory").val() : "";
            var originalsubcategory = $("#originalsubcategory").val();
            var selectedscope = favouritesOwnerType;
            var originalselectedscope = $("#originalselectedscope").val();
            var favouritestype = $("#favouritestype").val();
            $("#favouritesModal").modal("hide");
            $.notifyDefaults({
                delay: 0,
                allow_dismiss: false,
                newest_on_top: true,
                mouse_over: "pause",
                template: "<div data-notify=\"container\" class=\"col-xs-11 col-sm-3 alert alert-{0}\" role=\"alert\">" +
                    "<img data-notify=\"icon\">" +
                    "<div class=\"content\"><span data-notify=\"title\">{1}</span>" +
                    "<span data-notify=\"message\">{2}</span></div>" +
                    "</div>"
            });
            if (listname === originallistname && category === originalcategory && subcategory === originalsubcategory && selectedscope === originalselectedscope) {
                $.notifyDefaults({
                    delay: 5000,
                    timer: 500,
                    allow_dismiss: true,
                    newest_on_top: true,
                    mouse_over: 'pause',
                    template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                        '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
                        '<span data-notify="icon"></span>' +
                        '<div class="content"><span data-notify="title">{1}</span>' +
                        '<span data-notify="message">{2}</span></div>' +
                        '<div class="progress" data-notify="progressbar">' +
                        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div>' +
                        '</div>'
                });
                if (edit) {
                    $.notify({ title: "Info", message: "No changes made.", icon: "glyphicon glyphicon-info-sign" });
                }
                else {
                    $.notify({ title: "Warning", message: "Cannot make a copy when none of the settings have changed.", icon: "glyphicon glyphicon-warning-sign" }, { type: "warning" });
                }
                return;
            }
            var favourite = {
                Id: favouriteId,
                ListName: listname,
                SearchCategory: category,
                SearchSubCategory: subcategory,
                OwnerType: selectedscope,
                Type: favouritestype,
                Copy: !edit
            };
            var sending = $.notify({
                title: "Saving ...",
                message: "Please wait while we update this favourites list..."
            }, {
                icon_type: "image"
            });
            $.notifyDefaults({
                delay: 5000,
                timer: 500,
                allow_dismiss: true,
                newest_on_top: true,
                mouse_over: 'pause',
                template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                    '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
                    '<span data-notify="icon"></span>' +
                    '<div class="content"><span data-notify="title">{1}</span>' +
                    '<span data-notify="message">{2}</span></div>' +
                    '<div class="progress" data-notify="progressbar">' +
                    '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div>' +
                    '</div>'
            });
            $.ajax({
                type: "PUT",
                url: window.AppSettings.ApiUrl + "/api/v1/favourites",
                data: JSON.stringify(favourite),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data) {
                    var hasError = false;
                    sending.close();
                    for (var i = 0; i < data.messages.length; i++) {
                        var result = data.messages[i];
                        if (result.type === "Success" /* Success */) {
                            $.notify({
                                title: "Success", message: result.message, icon: "glyphicon glyphicon-ok-circle"
                            }, {
                                type: "success"
                            });
                        }
                        else {
                            $.notify({
                                title: "Ooops", message: result.message, icon: "glyphicon glyphicon-remove-circle"
                            }, {
                                type: "warning"
                            });
                            hasError = true;
                        }
                    }
                    if (!hasError) {
                        LoadFavouriteCategories(favouritesModalUrl, favouritesUrl);
                    }
                },
                error: function () {
                    sending.close();
                    $.notify({
                        title: "Dang It", message: "There was an error trying to save your favourites selection.", icon: "glyphicon glyphicon-remove-circle"
                    }, {
                        type: "danger"
                    });
                }
            });
        }
        function setupFavouriteSubCategories(parentCategory, ignorePersonal, favouriteType) {
            if (!ignorePersonal) {
                removePersonalFavourites();
            }
            var checkboxVisible = !!$("#cbTeamFavourite").length;
            var scopeVisible = !!$("#selectedscope").length;
            var scope = "Profile";
            if (scopeVisible) {
                scope = $("#selectedscope").val();
            }
            else if (checkboxVisible) {
                scope = ($("#cbTeamFavourite")[0]).checked ? "Outlet" : "Profile";
            }
            var subCategorySelector = removeSubCategories();
            subCategorySelector.enable();
            var subCategoryOptions = [];
            var $nodes = $("#options").find("[data-category='" + parentCategory + "'][data-favourite-owner-type='" + scope + "'] [data-sub-category][data-sub-category!='']");
            $nodes.map(function (index, elem) {
                subCategoryOptions.push({ DataSubCategory: $(elem).data("sub-category"), SubCategory: $(elem).data("sub-category") });
            });
            subCategorySelector.addOption(subCategoryOptions);
            if (!ignorePersonal) {
                setupFavouriteLists(parentCategory, undefined, favouriteType);
            }
        }
        function setupFavouriteCategories(favouriteOwnerType, ignorePersonal) {
            if (!ignorePersonal) {
                removePersonalFavourites();
            }
            removeSubCategories();
            var $categorySelector = $("#category");
            var categorySelector = $categorySelector[0].selectize;
            categorySelector.clearOptions();
            categorySelector.enable();
            var categoryOptions = [];
            var $nodes = $("#options").find("[data-category][data-category!=''][data-favourite-owner-type='" + favouriteOwnerType + "']");
            $nodes.map(function (index, elem) {
                categoryOptions.push({ DataCategory: $(elem).data("category"), Category: $(elem).data("category") });
            });
            categorySelector.addOption(categoryOptions);
        }
        function setupFavouriteLists(parentCategory, parentSubCategory, favouriteType) {
            var checkboxVisible = !!$("#cbTeamFavourite").length;
            var scopeVisible = !!$("#selectedscope").length;
            var scope = "Profile";
            if (scopeVisible) {
                scope = $("#selectedscope").val();
            }
            else if (checkboxVisible) {
                scope = ($("#cbTeamFavourite")[0]).checked ? "Outlet" : "Profile";
            }
            var $favouriteListSelector = $("#favouriteList");
            var favouriteListSelector = $favouriteListSelector[0].selectize;
            favouriteListSelector.clearOptions();
            favouriteListSelector.enable();
            var personalFavouritesOptions = [];
            var personalFavouritesValues = [];
            var $nodes;
            if (parentCategory !== undefined && parentSubCategory !== undefined) {
                $nodes = $("#options").find("[data-category='" + parentCategory + "'][data-favourite-owner-type='" + scope + "'] [data-sub-category='" + parentSubCategory + "'] li");
            }
            else if (parentCategory !== undefined && parentSubCategory === undefined) {
                $nodes = $("#options").find("[data-category='" + parentCategory + "'][data-favourite-owner-type='" + scope + "'] [data-sub-category][data-sub-category=''] li");
            }
            else {
                $nodes = $("#options").find("[data-category=''] li");
            }
            $nodes.map(function (index, elem) {
                personalFavouritesOptions.push({ FavouriteID: $(elem).data("favourite-id"), FavouriteName: $(elem).data("favourite-name") });
            });
            favouriteListSelector.addOption(personalFavouritesOptions);
            favouriteListSelector.setValue(personalFavouritesValues);
        }
        function removePersonalFavourites() {
            var $favouriteListSelector = $("#favouriteList");
            if ($favouriteListSelector.length) {
                var favouriteListSelector = $favouriteListSelector[0].selectize;
                favouriteListSelector.clearOptions();
                favouriteListSelector.disable();
            }
        }
        function removeSubCategories() {
            var $subCategorySelector = $("#subcategory");
            var subCategorySelector = $subCategorySelector[0].selectize;
            subCategorySelector.clearOptions();
            subCategorySelector.disable();
            return subCategorySelector;
        }
        function doScopeTrigger() {
            var selectedValue = $("#selectedscope").val();
            var displayCategory = selectedValue !== "Profile";
            $("#categoryPanel").toggle(true);
            setupFavouriteCategories(selectedValue, displayCategory);
            if (displayCategory) {
                $("#category").removeClass("ignore");
                $("#btnUpdateFavourite").data("favouritesOwnerType", selectedValue);
            }
            else {
                $("#category").addClass("ignore");
                $("#btnUpdateFavourite").data("favouritesOwnerType", "Profile");
            }
        }
        function doCheckBoxTrigger() {
            var displayCategory = ($("#cbTeamFavourite")[0]).checked;
            $("#categoryPanel").toggle(true);
            setupFavouriteCategories("Outlet", displayCategory);
            if (displayCategory) {
                $("#category").removeClass("ignore");
                $("#btnUpdateFavourite").data("favouritesOwnerType", "Outlet");
            }
            else {
                $("#category").addClass("ignore");
                $("#btnUpdateFavourite").data("favouritesOwnerType", "Profile");
            }
        }
        function saveFavourite(outletId, outletServiceId, categoryId, councilRegionId, type, searchCategory, searchSubCategory, name, userHasConfirmed) {
            // Ignore validation for IE < 9 as it's broken -- will defer to server-side checks
            if (!(document.all && !document.addEventListener)) {
                var form = $("#favouritesForm");
                if (!form.valid()) {
                    return;
                }
            }
            $("#favouritesModal").modal("hide");
            $.notifyDefaults({
                delay: 0,
                allow_dismiss: false,
                newest_on_top: true,
                mouse_over: "pause",
                template: "<div data-notify=\"container\" class=\"col-xs-11 col-sm-3 alert alert-{0}\" role=\"alert\">" +
                    "<img data-notify=\"icon\">" +
                    "<div class=\"content\"><span data-notify=\"title\">{1}</span>" +
                    "<span data-notify=\"message\">{2}</span></div>" +
                    "</div>"
            });
            var sending = $.notify({
                title: "Saving ...",
                message: "Please wait while we save this listing to your favourites ... ",
                icon: "/_static/images/processing.gif"
            }, {
                icon_type: "image"
            });
            var existingList = [];
            $("#favouriteList").val().split(",").map(function (e) { if (parseInt(e) > -1)
                existingList.push(e); });
            var existing = existingList.join(",");
            var newList = [];
            if (typeof name === "undefined") {
                newFavourites.map(function (e) { newList.push(e.FavouriteName); });
            }
            else {
                newList.push(name);
            }
            var favs = {
                OutletID: outletId,
                OutletServiceID: outletServiceId,
                CategoryID: categoryId,
                CouncilRegionID: councilRegionId,
                Existing: existing,
                NewList: newList.join(","),
                SearchCategory: searchCategory || $("#category").val(),
                SearchSubCategory: searchSubCategory || $("#subcategory").val(),
                OwnerType: type,
                UserHasConfirmed: userHasConfirmed || false
            };
            $.notifyDefaults({
                delay: 5000,
                timer: 500,
                allow_dismiss: true,
                newest_on_top: true,
                mouse_over: 'pause',
                template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                    '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
                    '<span data-notify="icon"></span>' +
                    '<div class="content"><span data-notify="title">{1}</span>' +
                    '<span data-notify="message">{2}</span></div>' +
                    '<div class="progress" data-notify="progressbar">' +
                    '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div>' +
                    '</div>'
            });
            $.ajax({
                type: "POST",
                url: window.AppSettings.ApiUrl + "/api/v1/favourites",
                data: JSON.stringify(favs),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data) {
                    var hasError = false;
                    sending.close();
                    // This favourite may already exist as a saved search so provide user with an opportunity to respond
                    if (data.data.RequiresConfirmation) {
                        var existingListName = data.data.ExistingListName;
                        $("#favouritesConfirmText").html("A saved search with the name <strong>" + existingListName + "</strong> already exists. Click OK to replace this saved search with a new favourites list.");
                        var $modal = $("#favouritesConfirmModal");
                        $modal.modal("show");
                        $("#btnFavouriteConfirm").off().on("click touchend", function () {
                            $modal.modal("hide");
                            saveFavourite(outletId, outletServiceId, categoryId, councilRegionId, type, searchCategory, searchSubCategory, existingListName, true);
                        });
                        return;
                    }
                    for (var i = 0; i < data.messages.length; i++) {
                        var result = data.messages[i];
                        if (result.type === "Success" /* Success */) {
                            $.notify({
                                title: "Success", message: result.message, icon: "glyphicon glyphicon-ok-circle"
                            }, {
                                type: "success"
                            });
                        }
                        else {
                            $.notify({
                                title: "Ooops", message: result.message, icon: "glyphicon glyphicon-remove-circle"
                            }, {
                                type: "warning"
                            });
                            hasError = true;
                        }
                    }
                    if (!hasError) {
                        $("#ddlSelectFavourite").val(null).trigger("change");
                        $("#txtNewFavourite").val('');
                    }
                },
                error: function () {
                    sending.close();
                    $.notify({
                        title: "Dang It", message: "There was an error trying to save your favourites selection.", icon: "glyphicon glyphicon-remove-circle"
                    }, {
                        type: "danger"
                    });
                }
            });
        }
        function setupDropDownTrigger(favouriteType) {
            $("#selectedscope").off("change").on("change", function () {
                var selectedValue = this.selectize.getValue();
                var displayCategory = this.selectize.options[selectedValue].$order > 1;
                //$("#categoryPanel").toggle(displayCategory);
                setupFavouriteCategories(selectedValue, displayCategory);
                if (selectedValue === "Organisation" || selectedValue === "Outlet") {
                    $("#category").removeClass("ignore");
                    $("#btnAddFavourite").data("favouritesOwnerType", selectedValue);
                }
                else if ($(this).val() === "Profile") {
                    setupFavouriteLists(undefined, undefined, favouriteType);
                    $("#category").addClass("ignore");
                    $("#btnAddFavourite").data("favouritesOwnerType", "Profile");
                }
            });
        }
        function setupCheckBoxTrigger(favouriteType) {
            $("#cbTeamFavourite").off("click touchend").on("click touchend", function () {
                //$("#categoryPanel").toggle(this.checked);
                if (!$("#categoryPanel:visible").length) {
                    setupFavouriteLists(undefined, undefined, favouriteType);
                    $("#category").addClass("ignore");
                    $("#btnAddFavourite").data("favouritesOwnerType", "Profile");
                }
                else {
                    setupFavouriteCategories("Outlet", false);
                    $("#category").removeClass("ignore");
                    $("#btnAddFavourite").data("favouritesOwnerType", "Outlet");
                }
            });
        }
        function bookmarkLink(evt, url) {
            var bTitle = document.title;
            var bUrl = window.location.protocol + "//" + window.location.host + url;
            $.notifyDefaults({
                type: "info",
                delay: 5000,
                timer: 500,
                allow_dismiss: true,
                newest_on_top: true,
                mouse_over: 'pause',
                template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                    '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
                    '<span data-notify="icon"></span>' +
                    '<div class="content"><span data-notify="title">{1}</span>' +
                    '<span data-notify="message">{2}</span></div>' +
                    '<div class="progress" data-notify="progressbar">' +
                    '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div>' +
                    '</div>'
            });
            try {
                // IE
                if ('AddFavorite' in window.external) {
                    evt.preventDefault();
                    window.external.AddFavorite(bUrl, bTitle);
                    $.notify({ title: "Success ...", message: "This page has been added to your browser favourites. To store favourites in a list you need to login.", icon: "glyphicon glyphicon-info-sign" });
                }
                // Older versions of FF
                else if ('addPanel' in window.sidebar) {
                    evt.preventDefault();
                    window.sidebar.addPanel(bTitle, bUrl);
                    $.notify({ title: "Success ...", message: "This page has been added to your browser favourites. To store favourites in a list you need to login.", icon: "glyphicon glyphicon-info-sign" });
                }
                // FF/Opera
                else if (window.opera || window.sidebar) {
                    $.notify({ title: "Success ...", message: "This page has been added to your browser favourites. To store favourites in a list you need to login.", icon: "glyphicon glyphicon-info-sign" });
                    //return true;
                    // Unsupported
                }
                else {
                    evt.preventDefault();
                    $.notify({ title: "Info ...", message: 'Your browser won\'t let me store this as a favourite for you automatically. Press ' + (navigator.userAgent.toLowerCase().indexOf('mac') !== -1 ? 'Command/Cmd' : 'CTRL') + ' + D to bookmark this page. To store favourites in a list you need to login.', icon: "glyphicon glyphicon-info-sign" });
                }
            }
            catch (err) {
                $.notify({ title: "Info ...", message: 'Your browser won\'t let me store this as a favourite for you automatically. Press ' + (navigator.userAgent.toLowerCase().indexOf('mac') !== -1 ? 'Command/Cmd' : 'CTRL') + ' + D to bookmark this page. To store favourites in a list you need to login.', icon: "glyphicon glyphicon-info-sign" });
            }
        }
        function saveSearch(crit, name, userHasConfirmed) {
            // Ignore validation for IE < 9 as it's broken -- will defer to server-side checks
            if (!(document.all && !document.addEventListener)) {
                var form = $("#favouritesForm");
                if (!form.valid()) {
                    return;
                }
            }
            $("#favouritesModal").modal("hide");
            $.notifyDefaults({
                delay: 0,
                allow_dismiss: false,
                newest_on_top: true,
                mouse_over: "pause",
                template: "<div data-notify=\"container\" class=\"col-xs-11 col-sm-3 alert alert-{0}\" role=\"alert\">" +
                    "<img data-notify=\"icon\">" +
                    "<div class=\"content\"><span data-notify=\"title\">{1}</span>" +
                    "<span data-notify=\"message\">{2}</span></div>" +
                    "</div>"
            });
            var sending = $.notify({
                title: "Saving ...",
                message: "Please wait while we save this search to your favourites ... ",
                icon: "/_static/images/processing.gif"
            }, {
                icon_type: "image"
            });
            var existingList = [];
            $("#favouriteList").val().split(",").map(function (e) { if (parseInt(e) > -1)
                existingList.push(e); });
            var existing = existingList.join(",");
            var newList = [];
            if (typeof name === "undefined") {
                newFavourites.map(function (e) { newList.push(e.FavouriteName); });
            }
            else {
                newList.push(name);
            }
            var saveAsList = $("#saveAsList").hasClass("active");
            var ownerType = $("#selectedscope").val();
            var category = $("#category").val();
            var subCategory = $("#subcategory").val();
            var favs = jQuery.extend({
                SortField: $("#hfSortField").val(),
                SortDirection: $("#hfSortDirection").val(),
                Existing: existing,
                NewList: newList.join(","),
                UserHasConfirmed: userHasConfirmed || false,
                SaveAsList: saveAsList,
                OwnerType: ownerType,
                SearchCategory: category,
                SearchSubCategory: subCategory
            }, crit);
            $.notifyDefaults({
                delay: 5000,
                timer: 500,
                allow_dismiss: true,
                newest_on_top: true,
                mouse_over: "pause",
                template: "<div data-notify=\"container\" class=\"col-xs-11 col-sm-3 alert alert-{0}\" role=\"alert\">" +
                    "<button type=\"button\" aria-hidden=\"true\" class=\"close\" data-notify=\"dismiss\">×</button>" +
                    "<span data-notify=\"icon\"></span>" +
                    "<div class=\"content\"><span data-notify=\"title\">{1}</span>" +
                    "<span data-notify=\"message\">{2}</span></div>" +
                    "<div class=\"progress\" data-notify=\"progressbar\">" +
                    "<div class=\"progress-bar progress-bar-{0}\" role=\"progressbar\" aria-valuenow=\"0\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 0%;\"></div></div>" +
                    "</div>"
            });
            $.ajax({
                type: "POST",
                url: window.AppSettings.ApiUrl + "/api/v1/favourites/savesearch",
                data: JSON.stringify(favs),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data) {
                    var hasError = false;
                    sending.close();
                    // This favourite may already exist as a favourites list so provide user with an opportunity to respond
                    if (data.data.RequiresConfirmation) {
                        var existingListName = data.data.ExistingListName;
                        $("#favouritesConfirmText").html("A favourites list with the name <strong>" + existingListName + "</strong> already exists. Click OK to merge the results of this saved search into the existing favourites list.");
                        var $modal = $("#favouritesConfirmModal");
                        $modal.modal("show");
                        $("#btnFavouriteConfirm").off().on("click touchend", function () {
                            $modal.modal("hide");
                            saveSearch(crit, existingListName, true);
                        });
                        return;
                    }
                    for (var i = 0; i < data.messages.length; i++) {
                        var result = data.messages[i];
                        if (result.type === "Success" /* Success */) {
                            $.notify({
                                title: "Success", message: result.message, icon: "glyphicon glyphicon-ok-circle"
                            }, {
                                type: "success"
                            });
                        }
                        else {
                            $.notify({
                                title: "Ooops", message: result.message, icon: "glyphicon glyphicon-remove-circle"
                            }, {
                                type: "warning"
                            });
                            hasError = true;
                        }
                    }
                    if (!hasError) {
                        $("#ddlSelectSavedSearch").val(null).trigger("change");
                        $("#txtSavedSearch").val("");
                    }
                },
                error: function () {
                    sending.close();
                    $.notify({
                        title: "Dang It", message: "There was an error trying to save your search.", icon: "glyphicon glyphicon-remove-circle"
                    }, {
                        type: "danger"
                    });
                }
            });
        }
        function ShowAddFavouriteList(loggedIn) {
            newFavourites = [];
            // reset form validation
            if ($("#favouritesForm .error").length !== 0) {
                var validator = $("#favouritesForm").validate();
                validator.resetForm();
            }
            // hide organisation favourites panel
            var cbOrganisationFavourite = $("#cbOrganisationFavourite");
            var isOrganisationFavourite = cbOrganisationFavourite.length !== 0 && (cbOrganisationFavourite.get(0)).checked;
            if (isOrganisationFavourite) {
                $("#cbOrganisationFavourite").trigger("click");
            }
            if (!loggedIn) {
                $.notify({ title: "Error", message: "You cannot save a search unless you're logged in.", icon: "glyphicon glyphicon-info-sign" });
                return;
            }
            $.ajax({
                type: "GET",
                url: "/FavouritesNewModalAjax",
                cache: false,
                success: function (data) {
                    $("#favouritesModal").html($("#favouritesCreateModalTemplate").render(data));
                    showAddFavourite(true);
                },
                error: function () {
                    $.notify({ title: "Error", message: "Something went wrong trying to retrieve favourites.", icon: "glyphicon glyphicon-info-sign" });
                }
            });
        }
        Favourites.ShowAddFavouriteList = ShowAddFavouriteList;
        function ShowAddFavourite(evt, outlet, service, category, region, url, favouriteModalUrl, loggedIn) {
            newFavourites = [];
            // reset form validation
            if ($("#favouritesForm .error").length !== 0) {
                var validator = $("#favouritesForm").validate();
                validator.resetForm();
            }
            // hide organisation favourites panel
            var cbOrganisationFavourite = $("#cbOrganisationFavourite");
            var isOrganisationFavourite = cbOrganisationFavourite.length !== 0 && (cbOrganisationFavourite.get(0)).checked;
            if (isOrganisationFavourite) {
                $("#cbOrganisationFavourite").trigger("click");
            }
            if (!loggedIn) {
                bookmarkLink(evt, url);
                return;
            }
            $.ajax({
                type: "GET",
                url: favouriteModalUrl.replace("0", outlet.toString()),
                cache: false,
                success: function (data) {
                    $("#favouritesModal").html($("#favouritesCreateModalTemplate").render(data));
                    $("#btnSaveSearchFavourite").data("outlet", outlet);
                    $("#btnSaveSearchFavourite").data("service", service);
                    $("#btnSaveSearchFavourite").data("category", category);
                    $("#btnSaveSearchFavourite").data("region", region);
                    showAddFavourite(false);
                },
                error: function () {
                    $.notify({ title: "Error", message: "Something went wrong trying to retrieve favourites.", icon: "glyphicon glyphicon-info-sign" });
                }
            });
        }
        Favourites.ShowAddFavourite = ShowAddFavourite;
        function showAddFavourite(isSearch) {
            var favouriteType = "Search";
            if (isSearch) {
                $("#saveAsSelectDiv").show();
            }
            else {
                $("#saveAsSelectDiv").hide();
                favouriteType = "List";
            }
            $("#createNewList").off("click").on("click", function () {
                $("#existingListDiv").hide(100);
                $("#createListDiv").show(100);
            });
            var $favouriteFolder = $("#favouriteFolder").selectize();
            var favouriteFolder = $favouriteFolder[0].selectize;
            $("#favouriteFolder").off("change").on("change", function () {
                var segs = $(this).val().split("|");
                selectedScopeSelector.setValue(segs[0], false);
                if (segs[1]) {
                    setTimeout(categorySelector.setValue(segs[1], false), 100);
                }
                else {
                    categorySelector.clear();
                }
                if (segs[2]) {
                    setTimeout(subCategorySelector.setValue(segs[2], false), 200);
                }
                else {
                    subCategorySelector.clear();
                }
            });
            var $selectedScopeSelector = $("#selectedscope").selectize({
                plugins: {
                    "no-delete": {},
                    "accessibility": { Label: "Would you like to share this favourite with others?" }
                }
            });
            var selectedScopeSelector = $selectedScopeSelector[0].selectize;
            var parentCategory = undefined;
            var parentSubCategory = undefined;
            $("#favouritesModal").modal({ backdrop: "static", show: true });
            $("#category").addClass("ignore");
            var favouritesModalForm = $("#favouritesForm");
            favouritesModalForm.validate({
                ignore: ".ignore",
                rules: {
                    "favouriteList": { required: true },
                    "category": { required: true }
                },
                messages: {
                    "favouriteList": { required: "A favourites list name must be provided." },
                    "category": { required: "A category must be provided." }
                },
                highlight: function (element) {
                    $(element).parent().attr("role", "alert");
                },
                unhighlight: function (element) {
                    $(element).parent().removeAttr("role");
                }
            });
            var currentId = -1;
            var $favouriteListSelector = $("#favouriteList").selectize({
                persist: true,
                maxItems: null,
                valueField: "FavouriteID",
                labelField: "FavouriteName",
                searchField: ["FavouriteName"],
                createOnBlur: true,
                plugins: {
                    "remove_button_accessible": {},
                    "accessibility": { Label: "Choose a favourites list or enter the name of a new one. Backspace to delete an entry" }
                },
                render: {
                    item: function (item, escape) {
                        return "<div><span>" + escape(item.FavouriteName) + "</span></div>";
                    },
                    option: function (item, escape) {
                        return "<div><span class=\"label\" style=\"color:black;\">" + escape(item.FavouriteName) + "</span></div>";
                    }
                },
                create: function (input) {
                    return { FavouriteID: currentId--, FavouriteName: input };
                },
                onOptionAdd: function (value, data) {
                    if (value < 0) {
                        newFavourites.push({ FavouriteID: data.FavouriteID, FavouriteName: data.FavouriteName });
                    }
                },
                onOptionRemove: function (value) {
                    var index = newFavourites.map(function (e) { return e.FavouriteID; }).indexOf(parseInt(value));
                    if (index > -1) {
                        newFavourites.splice(index, 1);
                    }
                    // Remove created items from options to allow persist: true
                    if (value < 0) {
                        favouriteListSelector.removeOption(value);
                    }
                }
            });
            var favouriteListSelector = $favouriteListSelector[0].selectize;
            if ($("#category").length) {
                var $subCategorySelector = $("#subcategory").selectize({
                    persist: false,
                    maxItems: 1,
                    valueField: "DataSubCategory",
                    labelField: "SubCategory",
                    searchField: ["SubCategory"],
                    createOnBlur: true,
                    plugins: { "accessibility": { Label: "Optionally, choose a sub-category or enter the name of a new one. Backspace to delete an entry" } },
                    render: {
                        item: function (item, escape) {
                            return "<div><span>" + escape(item.SubCategory) + "</span></div>";
                        },
                        option: function (item, escape) {
                            return "<div><span class=\"label\" style=\"color:black;\">" + escape(item.SubCategory) + "</span></div>";
                        }
                    },
                    create: function (input) {
                        return { DataSubCategory: input, SubCategory: input };
                    },
                    onChange: function (value) {
                        parentCategory = $("#category").val();
                        parentSubCategory = !value.length ? undefined : value;
                        setupFavouriteLists($("#category").val(), !value.length ? undefined : value, favouriteType);
                    }
                });
                // make operations (clear/disable/etc) available on sub-categories through var
                var subCategorySelector = $subCategorySelector[0].selectize;
                var $categorySelector = $("#category").selectize({
                    persist: false,
                    maxItems: 1,
                    valueField: "DataCategory",
                    labelField: "Category",
                    searchField: ["Category"],
                    createOnBlur: true,
                    plugins: { "accessibility": { Label: "Choose a category or enter the name of a new one. Backspace to delete an entry" } },
                    render: {
                        item: function (item, escape) {
                            return "<div><span>" + escape(item.Category) + "</span></div>";
                        },
                        option: function (item, escape) {
                            var label = item.Category || item.DataCategory;
                            return "<div><span class=\"label\" style=\"color:black;\">" + escape(label) + "</span></div>";
                        }
                    },
                    create: function (input) {
                        return { DataCategory: input, Category: input };
                    },
                    onChange: function (value) {
                        if (!value.length)
                            return;
                        parentCategory = value;
                        parentSubCategory = undefined;
                        setupFavouriteSubCategories(value, false, favouriteType);
                    }
                });
                // reset selection
                var categorySelector = $categorySelector[0].selectize;
                categorySelector.clear();
                subCategorySelector.disable();
                subCategorySelector.clear();
            }
            favouriteListSelector.disable();
            favouriteListSelector.clear();
            setupFavouriteLists(undefined, undefined, favouriteType);
            setupCheckBoxTrigger(favouriteType);
            setupDropDownTrigger(favouriteType);
            $("#saveAsQuery").off("click").on("click", function () {
                $("#saveAsList").removeClass("active");
                $("#saveAsList").removeClass("btn-blue");
                $(this).addClass("active");
                $(this).addClass("btn-blue");
                favouriteType = "Search";
                if ($("#selectedscope").val() === "Profile") {
                    parentCategory = undefined;
                    parentSubCategory = undefined;
                }
                setupFavouriteLists(parentCategory, parentSubCategory, favouriteType);
            });
            $("#saveAsList").off("click").on("click", function () {
                $("#saveAsQuery").removeClass("active");
                $("#saveAsQuery").removeClass("btn-blue");
                $(this).addClass("active");
                $(this).addClass("btn-blue");
                favouriteType = "List";
                if ($("#selectedscope").val() === "Profile") {
                    parentCategory = undefined;
                    parentSubCategory = undefined;
                }
                setupFavouriteLists(parentCategory, parentSubCategory, favouriteType);
            });
            if (window.sessionStorage.getItem("mcd-favourites-timer")) {
                var oldDate = new Date(window.sessionStorage.getItem("mcd-favourites-timer"));
                if (new Date() < new Date(oldDate.getTime() + 20 * 60000)) {
                    if (window.sessionStorage.getItem("mcd-favourites-folder")) {
                        favouriteFolder.setValue(window.sessionStorage.getItem("mcd-favourites-folder"));
                    }
                    if (window.sessionStorage.getItem("mcd-favourites-list")) {
                        favouriteListSelector.setValue(window.sessionStorage.getItem("mcd-favourites-list"));
                    }
                }
                else {
                    sessionStorage.removeItem("mcd-favourites-timer");
                    sessionStorage.removeItem("mcd-favourites-folder");
                    sessionStorage.removeItem("mcd-favourites-list");
                }
            }
            if (isSearch) {
                $("#btnSaveSearchFavourite").off("click touchend").on("click touchend", function (e) {
                    e.preventDefault();
                    window.sessionStorage.setItem("mcd-favourites-folder", $("#favouriteFolder").val());
                    window.sessionStorage.setItem("mcd-favourites-list", $("#favouriteList").val());
                    window.sessionStorage.setItem("mcd-favourites-timer", new Date().toString());
                    saveSearch(searchCrit);
                });
            }
            else {
                $("#btnSaveSearchFavourite").off("click touchend").on("click touchend", function (e) {
                    e.preventDefault();
                    window.sessionStorage.setItem("mcd-favourites-folder", $("#favouriteFolder").val());
                    window.sessionStorage.setItem("mcd-favourites-list", $("#favouriteList").val());
                    window.sessionStorage.setItem("mcd-favourites-timer", new Date().toString());
                    saveFavourite($(this).data("outlet"), $(this).data("service"), $(this).data("category"), $(this).data("region"), $("#selectedscope").val());
                });
            }
        }
        function SetupSaveSearchClick(crit) {
            searchCrit = crit;
        }
        Favourites.SetupSaveSearchClick = SetupSaveSearchClick;
        function SetSortButtonDirection(btn, direction, icon) {
            var ascClass = "icon-sort-" + icon + "-asc";
            var descClass = "icon-sort-" + icon + "-desc";
            if (direction === 'DESC') {
                btn.removeClass(ascClass).addClass(descClass);
            }
            else {
                btn.removeClass(descClass).addClass(ascClass);
            }
            btn.addClass("active").data("sort-direction", direction);
        }
        Favourites.SetSortButtonDirection = SetSortButtonDirection;
        function RemoveFavouritesList(favouriteId, favouritesUrl, reloadAction) {
            var sending = $.notify({
                title: "Removing ...",
                message: "Please wait while we remove this favourites list... ",
                icon: "/_static/images/processing.gif"
            }, {
                icon_type: "image"
            });
            $.ajax({
                type: "DELETE",
                url: window.AppSettings.ApiUrl + "/api/v1/favourites/" + favouriteId,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data) {
                    var hasError = false;
                    sending.close();
                    for (var i = 0; i < data.messages.length; i++) {
                        var result = data.messages[i];
                        if (result.type === "Success" /* Success */) {
                            $.notify({
                                title: "Success", message: result.message, icon: "glyphicon glyphicon-ok-circle"
                            }, {
                                type: "success"
                            });
                        }
                        else {
                            $.notify({
                                title: "Oops", message: result.message, icon: "glyphicon glyphicon-remove-circle"
                            }, {
                                type: "warning"
                            });
                            hasError = true;
                        }
                    }
                    if (!hasError) {
                        if (typeof reloadAction === "undefined") {
                            window.location.replace(favouritesUrl);
                        }
                        else {
                            reloadAction();
                        }
                    }
                },
                error: function () {
                    sending.close();
                    $.notify({
                        title: "Dang It", message: "There was an error trying to remove this favourites list.", icon: "glyphicon glyphicon-remove-circle"
                    }, {
                        type: "danger"
                    });
                }
            });
        }
        Favourites.RemoveFavouritesList = RemoveFavouritesList;
    })(Favourites = Common.Favourites || (Common.Favourites = {}));
})(Common || (Common = {}));
